<div *ngIf="radarService.detailsTab.active && !tabsService.minimizeScreenMode">

  <fieldset>
    <form #form="ngForm" [ngClass]="[tabsService.fullScreenMode ? 'fullscreen' : '']"
          autocomplete="off" class="active" >

      <div class="fields__block">
        <div class="fields__block__section">
          <div class="title">
            <h4>Radar Information</h4><span> </span>
          </div>

          <div class="input-fields">
            <div>
              <label for="name">Name</label>
              <input id="name" type="text" required
                     [(ngModel)]="radarService.detailsTab.selected.name" name="name"/>
            </div>
          </div>
        </div>

        <grit-groups
          [(accessGroup)]="radarService.detailsTab.selected.groupAccess"
          [(originatorGroup)]="radarService.detailsTab.selected.groupOriginator"
          [(visibilityGroup)]="radarService.detailsTab.selected.groupVisibility">
        </grit-groups>
      </div>

      <div class="fields__block">
        <div class="fields__block__section">
          <div class="title">
            <h4>Position</h4><span> </span>
          </div>

          <div class="input-fields">
            <div>
              <label>Latitude</label>
              <div class="coordenates">
                <div>
                  <select id="latitude-cardinal" name="lat-cardinal" required
                          [(ngModel)]="radarService.detailsTab.selected.latitude.cardinal"
                          style="width: auto;">
                    <option value="N">N</option>
                    <option value="S">S</option>
                  </select>

                  <input id="latitude-degrees" type="number" name="lat-degrees" required
                         [(ngModel)]="radarService.detailsTab.selected.latitude.degrees"
                         style="width: 16%;"><span>º</span>
                  <input id="latitude-minutes" type="number" name="~lat-minutes" required
                         [(ngModel)]="radarService.detailsTab.selected.latitude.minutes"
                         style="width: 16%;"><span>´</span>
                  <input id="latitude-seconds" type="number" name="lat-seconds" required
                         [(ngModel)]="radarService.detailsTab.selected.latitude.seconds"
                         style="width: 16%;"><span>´´</span>
                </div>

                <br />

                <input id="latitude-value" type="number" name="lat-value" required
                       [(ngModel)]="radarService.detailsTab.selected.latitude.value"
                       style="width: 65.5%; margin-top: 5px; margin-bottom: 5px;">
                <span>º</span>
                <span class="error" *ngIf="!radarService.detailsTab.selected.latitude.valid('value')">
                The Latitude value must be an integer number defined between -90º and 90º.
              </span>
                <span class="error" *ngIf="!radarService.detailsTab.selected.latitude.valid('degrees')">
                The Degrees value must be an integer number defined between 0º and 90º.
              </span>
                <span class="error" *ngIf="!radarService.detailsTab.selected.latitude.valid('minutes')">
                The Minutes value must be an integer number defined between 0 and 59 minutes.
              </span>
                <span class="error" *ngIf="!radarService.detailsTab.selected.latitude.valid('seconds')">
                The Seconds value must be defined between 0 and 59.99.
              </span>
              </div>
            </div>

            <div>
              <label>Longitude</label>
              <div class="coordenates">
                <div>
                  <select id="longitude-cardinal" name="lon-cardinal" required
                          [(ngModel)]="radarService.detailsTab.selected.longitude.cardinal"
                          style="width: auto;">
                    <option value="E">E</option>
                    <option value="W">W</option>
                  </select>

                  <input id="longitude-degrees" type="number" name="lon-degrees" required
                         [(ngModel)]="radarService.detailsTab.selected.longitude.degrees"
                         style="width: 16%;"><span>º</span>
                  <input id="longitude-minutes" type="number" name="lon-minutes" required
                         [(ngModel)]="radarService.detailsTab.selected.longitude.minutes"
                         style="width: 16%;"><span>´</span>
                  <input id="longitude-seconds" type="number" name="lon-seconds" required
                         [(ngModel)]="radarService.detailsTab.selected.longitude.seconds"
                         style="width: 16%;"><span>´´</span>
                </div>
                <br/>
                <input id="longitude-value" type="number" name="lon-value" required
                       [(ngModel)]="radarService.detailsTab.selected.longitude.value"
                       style="width: 65.5%; margin-top: 5px; margin-bottom: 5px;">
                <span>º</span>
                <span class="error" *ngIf="!radarService.detailsTab.selected.longitude.valid('value')">
                The Longitude value must be an integer number defined between -90º and 90º.
              </span>
                <span class="error" *ngIf="!radarService.detailsTab.selected.longitude.valid('degrees')">
                The Degrees value must be an integer number defined between 0º and 90º.
              </span>
                <span class="error" *ngIf="!radarService.detailsTab.selected.longitude.valid('minutes')">
                The Minutes value must be an integer number defined between 0 and 59 minutes.
              </span>
                <span class="error" *ngIf="!radarService.detailsTab.selected.longitude.valid('seconds')">
                The Seconds value must be defined between 0 and 59.99.
              </span>
              </div>
            </div>

            <div>
              <label for="radius">Range</label>
              <input id="radius" type="number" name="range"
                     [(ngModel)]="radarService.detailsTab.selected.radius"/><span>[Km]</span>
            </div>
          </div>
        </div>
      </div>

      <div class="fields__btn">
        <button type="submit" (click)="submit(radarService.detailsTab.selected.id == 0)" [disabled]="!form.form.valid || !groupsNotNull(radarService.detailsTab.selected)"
                [ngClass]="form.form.valid && groupsNotNull(radarService.detailsTab.selected) ? 'blue' : 'gray'" >Save</button>
        <button (click)="tabsService.closeTab()" class="gray" href="#" type="reset" value="Cancel">Cancel</button>
      </div>
    </form>
  </fieldset>

</div>
